<template>
    <div class="main-content">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h6>Роли <button class="btn btn-success btn-sm pull-right" @click="mixinGoToRouter('settingsAccessRoleEdit',{id:'new'})">Новая роль</button></h6>
                    </div>
                    <div class="card-body">

                        <table class="table table-hover table-sm table-striped">
                          <thead>
                          <tr>
                            <th></th>
                            <th>ID</th>
                            <th>Роль</th>
                            <th>Название</th>
                            <th>Дата создания</th>
                            <th></th>
                          </tr>
                          </thead>
                            <tbody>
                            <tr v-for="(record, index) in records">
                                <td>{{(index + 1) + ((paginator.current_page - 1) * paginator.per_page)}}</td>
                                <td>{{record.id}}</td>
                                <td>{{record.name}}</td>
                                <td>{{record.name_title}}</td>
                                <td>{{record.created_at}}</td>
                                <td><a @click="mixinGoToRouter('settingsAccessRoleEdit',{id:record.id})"
                                       class="btn btn-sm btn-info">Редактировать</a></td>
                            </tr>
                            </tbody>
                        </table>

                        <div class="text-right">
                            <paginate v-if="paginator"
                                      :page-count="paginator.last_page"
                                      :page-range="3"
                                      :margin-pages="2"
                                      :click-handler="getRoles"
                                      :prev-text="'&laquo'"
                                      :next-text="'&raquo'"
                                      :container-class="'pagination'"
                                      :prev-class="'page-item'"
                                      :prev-link-class="'page-link'"
                                      :page-class="'page-item'"
                                      :page-link-class="'page-link'"
                                      :next-class="'page-item'"
                                      :next-link-class="'page-link'"
                                      :active-class="'active green_btn'">
                            </paginate>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<style scoped>

    .text-rigth {
        padding-right: 10px;
    }

    .pagination {
        justify-content: flex-end;
    }

    a.btn {
        cursor: pointer;
        color: white;
    }

    a.btn:hover {
        color: white;
    }

</style>

<script>
    import api from '@/api'
    import Paginate from 'vuejs-paginate'

    export default {
        components: {
            Paginate,
        },
        data() {
            return {
                records: null,
                paginator: null
            }
        },
        mounted() {
            this.getRoles()
        },
        methods: {
            async getRoles() {
                let {data: r_data} = await api.index('/settings/getRoles')
                const {data, ...pagination} = r_data.records
                this.paginator = pagination
                this.records = data
            },
        }
    }
</script>
